import { Mentee } from "../types/response/LeaderMenteesPlanResponse"

const findEarliestHour = (mentees: Mentee[]): number => {
  const allHours = mentees.flatMap(mentee =>
    mentee.workSchedule.flatMap(schedule => 
      schedule.shifts.map(shift => parseInt(shift.from.split(':')[0], 10))
    )
  )

  return allHours.length ? Math.min(...allHours) : 8
}

export default findEarliestHour